<template>
    <b-form-group
      :label="label"
      :label-for="id"
    >
        <multiselect 
            :id="id"
            v-model="valueLocal" 
            :options="options" 
            placeholder="" 
            selectLabel="Clique para adicionar"
            deselectLabel="Clique para remover"
            selectedLabel="Selecionado"
            label="text" 
            track-by="value" 
            :multiple="true" 
            :taggable="true"
            @input="onInput"
            :disabled="disabled"
            />
    </b-form-group>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props :{
        options : {
            type : Array,
            required : true
        },
        value : {
            type : Array,
            required : true
        },
        label : {
            type : String,
            required : true
        },
        id: {
            type : String,
            required : true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data : () => ({
        valueLocal : [],
    }),
    methods : {
        onInput : function(value){
            this.$emit('input', value.map(el => el.value));
        }
    },
    watch : {
        value : function(value){
            let values = [];
            value.forEach(el => {
                values.push(this.options.find(element => element.value == el));
            });
            this.valueLocal = values;
        },
        options : function(){
            let values = [];
            this.value.forEach(el => {
                values.push(this.options.find(element => element.value == el));
            });
            this.valueLocal = values;
        }
    },
    mounted(){
        let values = [];
        this.value.forEach(el => {
            values.push(this.options.find(element => element.value == el));
        });
        this.valueLocal = values;
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect__option--highlight, .multiselect__option--highlight:after {
        background: #EEC068;
        outline: none;
        color: #fff;
    }

    .multiselect__option, .multiselect__option:after {
        line-height: 0;
        font-size: 0.875rem;
        min-height: auto;
        top: inherit;
    }

    .multiselect {
        box-sizing: inherit;
    }

    .multiselect__tag {
        background: #EEC068;
    }

    .multiselect__content-wrapper {
        width: calc(100% - 20px);
    }

    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: #c18f31;
    }

    .multiselect__option--selected {
        font-weight: inherit;
    }
</style>